import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseUrl } from "../Univ";

function PurchaseOrderPrint() {

    const { id } = useParams();

    const [order, setOrder] = useState(null);

    const [items, setItems] = useState([]);

    useEffect(() => {

        loadPurchaseOrder();

    }, []);

    const loadPurchaseOrder = async () => {

        try {

            // Purchase Order Header

            const res = await axios.get(

                baseUrl + "update-purchase-order/" + id + "/"

            );

            setOrder(res.data);

            // Purchase Order Items

            const itemRes = await axios.get(

                baseUrl + "purchase-order-item/" + id + "/"

            );

            setItems(itemRes.data);

        }

        catch (err) {

            console.log(err);

        }

    };

    const handlePrint = () => {

        const printContents =
            document.getElementById("print-area").innerHTML;

        const originalContents =
            document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        setTimeout(() => {

            window.location.reload();

        }, 500);

        document.body.innerHTML = originalContents;

    };

    if (!order) {

        return (

            <div className="container mt-5 text-center">

                <h4>Loading Purchase Order...</h4>

            </div>

        );

    }

    return (

        <section className="container-fluid">

            <div id="print-area">

                {/* ================================================= */}

                {/* COMPANY HEADER */}

                {/* ================================================= */}

                <table
                    width="100%"
                    cellPadding="5"
                >

                    <tbody>

                    <tr>

                        <td width="70%">

                            <h2
                                style={{
                                    color: "#198754",
                                    marginBottom: 0
                                }}
                            >
                                EAgri ERP
                            </h2>

                            <h5
                                style={{
                                    marginTop: 5
                                }}
                            >
                                MGM EBuild Private Limited
                            </h5>

                            <div>

                                Chennai, Tamil Nadu

                            </div>

                            <div>

                                support@mgmebuild.com

                            </div>

                            <div>

                                +91 XXXXX XXXXX

                            </div>

                        </td>

                        <td
                            width="30%"
                            align="right"
                        >

                            <h2
                                style={{
                                    border: "2px solid #198754",
                                    padding: "10px",
                                    color: "#198754"
                                }}
                            >
                                PURCHASE ORDER
                            </h2>

                        </td>

                    </tr>

                    </tbody>

                </table>

                <hr />
                        {/* ==========================================
                    PURCHASE ORDER DETAILS
                =========================================== */}

                <table
                    width="100%"
                    border="1"
                    cellPadding="6"
                    style={{
                        marginTop: "20px",
                        borderCollapse: "collapse"
                    }}
                >

                    <tbody>

                    <tr>

                        <td width="20%">
                            <b>PO No</b>
                        </td>

                        <td width="30%">
                            {order.po_no}
                        </td>

                        <td width="20%">
                            <b>Order Date</b>
                        </td>

                        <td width="30%">
                            {order.order_date}
                        </td>

                    </tr>

                    <tr>

                        <td>
                            <b>Supplier</b>
                        </td>

                        <td>
                            {order.supplier?.name}
                        </td>

                        <td>
                            <b>Quotation</b>
                        </td>

                        <td>
                            {order.quotation?.quotation_no}
                        </td>

                    </tr>

                    <tr>

                        <td>
                            <b>Expected Date</b>
                        </td>

                        <td>
                            {order.expected_date}
                        </td>

                        <td>
                            <b>Status</b>
                        </td>

                        <td>

                            <span
                                style={{
                                    color:
                                        order.status === "APPROVED"
                                            ? "green"
                                            : order.status === "REJECTED"
                                            ? "red"
                                            : "#d97706",
                                    fontWeight: "bold"
                                }}
                            >
                                {order.status}
                            </span>

                        </td>

                    </tr>

                    <tr>

                        <td>

                            <b>Remarks</b>

                        </td>

                        <td colSpan="3">

                            {order.remarks || "-"}

                        </td>

                    </tr>

                    </tbody>

                </table>

                {/* ==========================================
                    PURCHASE ORDER ITEMS
                =========================================== */}

                <h4
                    style={{
                        marginTop: "30px",
                        color: "#198754"
                    }}
                >
                    Purchase Order Items
                </h4>

                <table
                    width="100%"
                    border="1"
                    cellPadding="7"
                    style={{
                        borderCollapse: "collapse"
                    }}
                >

                    <thead>

                    <tr
                        style={{
                            background: "#198754",
                            color: "#fff"
                        }}
                    >

                        <th width="6%">
                            #
                        </th>

                        <th width="36%">
                            Item
                        </th>

                        <th width="12%">
                            Unit
                        </th>

                        <th width="12%">
                            Qty
                        </th>

                        <th width="12%">
                            Rate
                        </th>

                        <th width="22%">
                            Total
                        </th>

                    </tr>

                    </thead>

                    <tbody>

                    {items.map((item, index) => (

                        <tr key={item.id}>

                            <td align="center">

                                {index + 1}

                            </td>

                            <td>

                                {item.item?.item_name}

                            </td>

                            <td align="center">

                                {item.item?.unit}

                            </td>

                            <td align="right">

                                {Number(item.quantity).toFixed(2)}

                            </td>

                            <td align="right">

                                ₹ {Number(item.rate).toFixed(2)}

                            </td>

                            <td align="right">

                                ₹ {Number(item.total).toFixed(2)}

                            </td>

                        </tr>

                    ))}

                    </tbody>

                    <tfoot>

                    <tr>

                        <td
                            colSpan="5"
                            align="right"
                        >

                            <b>Grand Total</b>

                        </td>

                        <td
                            align="right"
                        >

                            <b>

                                ₹ {Number(order.total).toFixed(2)}

                            </b>

                        </td>

                    </tr>

                    </tfoot>

                </table>
                        {/* ==========================================
                    APPROVAL / SIGNATURES
                =========================================== */}

                <table
                    width="100%"
                    style={{
                        marginTop: "60px"
                    }}
                >

                    <tbody>

                    <tr>

                        <td align="center">

                            ___________________________

                            <br/><br/>

                            Prepared By

                        </td>

                        <td align="center">

                            ___________________________

                            <br/><br/>

                            Purchase Manager

                        </td>

                        <td align="center">

                            ___________________________

                            <br/><br/>

                            Approved By

                        </td>

                        <td align="center">

                            ___________________________

                            <br/><br/>

                            Supplier Acceptance

                        </td>

                    </tr>

                    </tbody>

                </table>

            </div>

            <div
                className="text-center mt-4 mb-5"
            >

                <button
                    className="btn btn-success"
                    onClick={handlePrint}
                >

                    Print Purchase Order

                </button>

            </div>

        </section>

    );

}

export default PurchaseOrderPrint;